export default __webpack_public_path__ + "static/instructions_svg-079fb27077091ac2361da8779bed3b83.svg";